<script setup>
import { computed } from 'vue';

const props = defineProps({
	width: {
		type: String,
		default: '100%',
	},
	height: {
		type: String,
		default: null,
	},
	aspectRatio: {
		type: String,
		default: null,
	},
	additionalClasses: {
		type: String,
		default: '',
	},
})

const cssVars = computed(() => ({
		'--width': `${props.width?.endsWith('%') ? props.width : props.width + 'px'}`,
		'--height': `${props.height?.endsWith('%') ? props.height : props.height + 'px'}`,
		'--aspect-ratio': `${props.aspectRatio}`,
	})
);

</script>

<template>
	<div
		:style="cssVars"
		class="c-skeleton__element c-skeleton-box"
		:class="additionalClasses"
	></div>
</template>

<style lang="scss" scoped>
@import "shared/styles/settings/settings";
@import "shared/styles/tools/tools";

.c-skeleton-box {
	aspect-ratio: var(--aspect-ratio);
	background-color: ds-color('bg', 'neutral');
	border-radius: t-rem(4px);
	height: var(--height);
	margin: 0 0 8px;
	width: var(--width);
}

</style>
